import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconCropSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.922 4v11.289H20v2h-2.21v2.712h-2v-2.712H7.92a1 1 0 0 1-1-1V8.746H4v-2h2.922V4h2Zm6.867 4.747h-4.775v-2h5.775a1 1 0 0 1 1 1v6.574h-2V8.747Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconCropSharp);
export default Memo;
